import { Col, Form, Modal, Row, Select } from 'antd';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import actions from '../store/actions/edit-document.actions';
import { EditDocumentIcon } from '../../../resource/icons';
import { dspxGetChildrens } from '../../../helpers/dspx-utils';
import useDocsTopicsQuery from '../queries/useDocsTopicsQuery';
import useDocsAppealTopicsQuery from '../queries/useDocsAppealTopicsQuery';
import { docTypes } from '../constants/documents.constants';
import useChangeDocTopicId from '../mutation/useChangeDocTopicId';
import { documentsActions } from '../store/actions/documents.actions';

const EditTopicIdModal = ({
  topicId,
  docType,
  getFieldDecorator,
  visible,
  onCancel,
  validateFields,
  prepareDataAndResetFields,
}) => {
  const dispatch = useDispatch();
  const subject = 'Тема';
  const subject_err = 'тему документа';

  const { data: topicsData = [] } = useDocsTopicsQuery({
    staleTime: Infinity,
  });

  const { data: appealTopicsData = [] } = useDocsAppealTopicsQuery({
    staleTime: Infinity,
  });

  const { changeDocTopicId } = useChangeDocTopicId();

  const updateStatusOnOk = useCallback(() => {
    validateFields(async (err, values) => {
      if (err) return;
      if (Number(values?.topicId) === topicId) {
        dispatch(actions.closeModal());
        return;
      }

      const doc = prepareDataAndResetFields(values);

      try {
        await changeDocTopicId({
          docId: doc?.id,
          topicId: Number(values?.topicId),
        });
        dispatch(documentsActions.fetchDocuments());
        dispatch(actions.closeModal());
      } catch (e) {
        console.error(e);
        dispatch(actions.closeModal());
      }
    });
  }, [dispatch, validateFields]);

  const optionsTopic =
    docType === docTypes.citizenAppeal ? appealTopicsData : topicsData;

  return (
    <Modal
      style={{ minWidth: 400 }}
      width={500}
      visible={visible}
      title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <EditDocumentIcon
            style={{
              height: 40,
              verticalAlign: 'middle',
              marginRight: 10,
            }}
          />
          <div>Тема документа</div>
        </div>
      }
      okText="Изменить"
      onCancel={onCancel}
      onOk={updateStatusOnOk}
    >
      <Form layout="vertical">
        <Row gutter={8}>
          <Col span={24}>
            <Form.Item label={subject}>
              {getFieldDecorator('topicId', {
                initialValue: String(topicId),
                rules: [
                  {
                    required: true,
                    message: 'Пожалуйста, укажите ' + subject_err,
                  },
                ],
              })(
                <Select
                  showSearch
                  placeholder="Тема"
                  notFoundContent="нет данных"
                  optionFilterProp="searchtext"
                >
                  {dspxGetChildrens(optionsTopic)}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditTopicIdModal;
